export enum PageSize {
    T = 10,
    S = 25,
    M = 50,
    L = 100,
    XL = 5000,
}
